/**
 * ProjectCreatePage Component
 *
 * Page for creating a new project
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCreateProject } from '../hooks/useProjects';
import { ProjectForm } from '../components/projects/ProjectForm';
import { ProjectFormData } from '../utils/validation';
import toast from 'react-hot-toast';

export const ProjectCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const createMutation = useCreateProject();

  const handleSubmit = async (data: ProjectFormData) => {
    try {
      await createMutation.mutateAsync(data);
      toast.success('Project created successfully');
      navigate('/projects');
    } catch (error) {
      toast.error(error instanceof Error ? error.message : 'Failed to create project');
    }
  };

  const handleCancel = () => {
    navigate('/projects');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <h1 className="text-3xl font-bold text-gray-900">Create New Project</h1>
          <p className="mt-1 text-sm text-gray-500">
            Create a new web agent project template
          </p>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white border border-gray-200 rounded-lg p-6">
          <ProjectForm
            onSubmit={handleSubmit}
            onCancel={handleCancel}
            isLoading={createMutation.isPending}
            submitLabel="Create Project"
          />
        </div>
      </main>
    </div>
  );
};
